//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import {nameReg} from '@/utils/regular.js'
export default {
    data(){
        return {
           applicantName:'',
        }
    },
    props: {
        verify:{ // 是否验证失败
            type: Boolean,
            default() { return false; }
        },
        placeholder:{ // placeholder 文字
            type: String,
            default() { return ''; }
        },
        com_id:{ // 组件唯一id，同一页面多次引用此组件时进行区分
            type: String,
            default:'inputName'
        },
    },
    watch:{
        applicantName(val){
            val = val.trim();
            let nameFlag;
            nameFlag = nameReg.test(val)
            if(val.length <2 && nameFlag){
                nameFlag = false;
            }
            this.$emit('nameEmit',{
                name:val,
                nameFlag:nameFlag
            })
        },
        verify(val){
            this.verify = val
        }
    },
    created() {
        this.bus.$on("nameInputFlag", (msg)=> {
            this.applicantName = msg
        });
        
    },
    methods:{
        cleanInfo(string = ''){
            this.applicantName = string
        },
        scrollInto(){
            
            window.setTimeout(function () {
                const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop ;
                if(scrollHeight){
                    window.scrollTo(0, Math.max(scrollHeight - 1, 0));
                }
                //console.log(Math.max(scrollHeight - 1, 0))
            }, 0);
            this.$emit('onBlur',{
                inputText:this.applicantName,
                message:this.com_id
            })
            
        }
    }
}
